import { render, staticRenderFns } from "./dev-attr-crud-vuetify.vue?vue&type=template&id=1912bc71"
import script from "./dev-attr-crud-vuetify.vue?vue&type=script&lang=js"
export * from "./dev-attr-crud-vuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports